/**
 * HotelSDK.ready 调用队列(B10 脚本竞态,阶段2 先搭壳)
 *
 * SDK 以 <script defer> 引入,加载时 DOM 通常已解析完成;
 * 但为兼容非 defer / head 内引入,markReady 在 DOMContentLoaded 后触发。
 * ready(cb):已就绪立即调用,否则入队,markReady 时统一 flush。
 */

let isReady = false;
const queue: Array<() => void> = [];

function safeCall(cb: () => void): void {
  try {
    cb();
  } catch (e) {
    // 单个回调异常不影响后续
    console.error('[HotelSDK] ready callback error:', e);
  }
}

/** 注册 ready 回调:已就绪立即调用,否则入队 */
export function onReady(cb: () => void): void {
  if (typeof cb !== 'function') return;
  if (isReady) {
    safeCall(cb);
    return;
  }
  queue.push(cb);
}

/** 标记 SDK 就绪并 flush 队列(幂等) */
export function markReady(): void {
  if (isReady) return;
  isReady = true;
  let cb = queue.shift();
  while (cb) {
    safeCall(cb);
    cb = queue.shift();
  }
}

/** 仅供测试/调试 */
export function getIsReady(): boolean {
  return isReady;
}
